import { Timestamp } from 'firebase/firestore';

import { parseDeltaComment } from './reviewCommentParsing';
import { extractReviewPhotoFields } from './reviewPhotoFields';
import { parseReactionSummary } from './reviewReactionTypes';

/**
 * @param {import('firebase/firestore').Timestamp | Date | string | number | undefined} dateValue
 * @returns {Date}
 */
export function normalizeHospitalityReviewDate(dateValue) {
  if (dateValue instanceof Timestamp) {
    return dateValue.toDate();
  }
  if (dateValue) {
    return new Date(dateValue);
  }
    return new Date();
}

function normalizeOptionalHospitalityReviewDate(dateValue) {
  if (dateValue == null || dateValue === '') {
    return undefined;
  }
  return normalizeHospitalityReviewDate(dateValue);
}

/**
 * @param {object} params
 * @param {string} params.reviewId
 * @param {object} params.reviewData
 * @param {string} [params.breweryName]
 * @param {string} [params.userName]
 * @returns {object}
 */
export function mapHospitalityReviewDoc({
  reviewId,
  reviewData,
  breweryName = 'Unknown Brewery',
  userName = 'Unknown User',
}) {
  const safeReviewData =
    reviewData && typeof reviewData === 'object' ? reviewData : {};
  const photoFields = extractReviewPhotoFields(safeReviewData);

  return {
    id: reviewId,
    breweryId: safeReviewData.breweryId,
    breweryName,
    userId: safeReviewData.uid,
    userName,
    date: normalizeHospitalityReviewDate(safeReviewData.date),
    editedAt: normalizeOptionalHospitalityReviewDate(safeReviewData.editedAt),
    experienceDate: normalizeOptionalHospitalityReviewDate(safeReviewData.experienceDate),
    comment: parseDeltaComment(safeReviewData.comment),
    ratings: {
      atmosphere: safeReviewData.atmosphereRating || 0,
      food: safeReviewData.foodRating || 0,
      quality: safeReviewData.qualityRating || 0,
      service: safeReviewData.serviceRating || 0,
    },
    reactionSummary: parseReactionSummary(safeReviewData.reactionSummary),
    photoIds: photoFields.photoIds,
    photoRevision: photoFields.photoRevision,
    photoSummary: photoFields.photoSummary,
  };
}
